import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import CustomOrder from "@/pages/CustomOrder";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminProducts from "@/admin/AdminProducts";
import AdminCategories from "@/admin/AdminCategories";
import AdminOrders from "@/admin/AdminOrders";
import AdminCustomOrders from "@/admin/AdminCustomOrders";
import AdminMessages from "@/admin/AdminMessages";
import AdminHomepage from "@/admin/AdminHomepage";
import AdminSettings from "@/admin/AdminSettings";

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="urunler" element={<Products />} />
              <Route path="urunler/:categorySlug" element={<Products />} />
              <Route path="urun/:slug" element={<ProductDetail />} />
              <Route path="sepet" element={<Cart />} />
              <Route path="odeme" element={<Checkout />} />
              <Route path="kisiye-ozel" element={<CustomOrder />} />
              <Route path="hikayemiz" element={<About />} />
              <Route path="iletisim" element={<Contact />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="custom-orders" element={<AdminCustomOrders />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="homepage" element={<AdminHomepage />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
